<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
  
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="mb-2 float-end">
                <b-button v-b-modal.new-category size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Category</b-button>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                    <label class="d-inline-flex align-items-center">
                      Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(addedby)="data">
                  {{ data.item.addedby }}
                </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                  <b-button @click="edit(data.item.id,data.item.name )" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                  <b-button @click="remove(data.item.id,data.item.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                  </div>
                </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <b-modal id="new-category" centered title="New Product Category" title-class="font-18" hide-footer>
          <div class="app-modal-banner">
            <div class="app-modal-banner-icon">
              <i class="mdi mdi-folder-plus-outline"></i>
            </div>
            <div class="app-modal-banner-copy">
              <div class="app-modal-banner-title">Create a new category</div>
              <div class="app-modal-banner-sub">
                Hover the <i class="mdi mdi-information-outline"></i> next to any field to see what it means.
              </div>
            </div>
          </div>
          <form @submit.prevent="addCategory">
              <div class="form-group mb-2">
              <label class="field-label" for="category-input-name">
                <span>Name</span>
                <i class="mdi mdi-information-outline help-icon" id="category-help-name" tabindex="0"></i>
              </label>
              <b-popover id="popover-category-name" target="category-help-name" triggers="hover focus" placement="right" custom-class="app-help-popover">
                <template #title>
                  <div class="app-help-popover-titlebar">
                    <span>About: Name</span>
                    <button type="button" class="app-help-popover-close" aria-label="Close" @click="closeHelp('popover-category-name')">
                      <i class="mdi mdi-close"></i>
                    </button>
                  </div>
                </template>
                Enter the category name staff will use to group related medicines or stock items &mdash; for example "Antibiotics", "Vitamins" or "First Aid". Keep it short and consistent so it's easy to find on the product list.
              </b-popover>
              <input id="category-input-name" v-model="name" type="text" class="form-control" />
              </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-category')" :disabled="categorySaving" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" :disabled="categorySaving" >
                    <b-spinner v-if="categorySaving" small class="align-middle me-1"></b-spinner>
                    <i v-else class="fas fa-check-circle"></i>
                    {{ categorySaving ? 'Saving...' : 'Submit' }}
                  </b-button>
              </div>
          </form>
      </b-modal>

      <b-modal id="edit-category" centered title="Edit Product Category" title-class="font-14" hide-footer>
          <div class="app-modal-banner">
            <div class="app-modal-banner-icon">
              <i class="mdi mdi-folder-edit-outline"></i>
            </div>
            <div class="app-modal-banner-copy">
              <div class="app-modal-banner-title">Update this category</div>
              <div class="app-modal-banner-sub">
                Hover the <i class="mdi mdi-information-outline"></i> next to any field to see what it means.
              </div>
            </div>
          </div>
          <form @submit.prevent="editCategory">
              <div class="form-group mb-2">
              <input v-model="id" type="hidden">
              <label class="field-label" for="category-input-edit-name">
                <span>Category Name</span>
                <i class="mdi mdi-information-outline help-icon" id="category-help-edit-name" tabindex="0"></i>
              </label>
              <b-popover id="popover-category-edit-name" target="category-help-edit-name" triggers="hover focus" placement="right" custom-class="app-help-popover">
                <template #title>
                  <div class="app-help-popover-titlebar">
                    <span>About: Category Name</span>
                    <button type="button" class="app-help-popover-close" aria-label="Close" @click="closeHelp('popover-category-edit-name')">
                      <i class="mdi mdi-close"></i>
                    </button>
                  </div>
                </template>
                Update the category name staff use to group related medicines or stock items. Renaming the category here updates it everywhere this category is shown across the system.
              </b-popover>
              <input id="category-input-edit-name" v-model="name" type="text" class="form-control" />
              </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-category')" :disabled="categoryEditSaving" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" :disabled="categoryEditSaving" >
                    <b-spinner v-if="categoryEditSaving" small class="align-middle me-1"></b-spinner>
                    <i v-else class="fas fa-check-circle"></i>
                    {{ categoryEditSaving ? 'Saving...' : 'Submit' }}
                  </b-button>
              </div>
          </form>
      </b-modal>
  
      <b-modal id="delete-category" centered title="Delete Product Category" title-class="font-18" hide-footer>
          <form @submit.prevent="removeCategory">
              <input v-model="id" type="hidden">
                Are you sure you want to delete the Category : <b>{{ name }}</b> ?
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-category')" :disabled="categoryDeleteSaving" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" :disabled="categoryDeleteSaving" >
                    <b-spinner v-if="categoryDeleteSaving" small class="align-middle me-1"></b-spinner>
                    <i v-else class="fas fa-check-circle"></i>
                    {{ categoryDeleteSaving ? 'Deleting...' : 'YES' }}
                  </b-button>
              </div>
          </form>
      </b-modal>
  
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  import Layout from "../../layouts/main";
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import { productcategoryMethods, productcategoryComputed } from "@/state/helpers";
  
  export default {
    page: {
      title: "Product Categories",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    components: {
      Layout,PageHeader
    },
    data() {
      return {
        title: "Product Categories",
        items: [ {text: "Dashboard",to: "/",}, {text: "Product Categories",active: true, }, ],
        TotalRows: 1,
        currentPage: 1,
        perPage: 10,
        Options: [10, 50, 100, 150, 200],
        filter: null,
        todoFilter: null,
        filterOn: [],
        sortDesc: true,
        isBusy: true,
        fields: [
            { key: 'index', label: '#', visible: true },
            { key: 'id', label: 'ID', visible: false },
            { key: 'name', label: 'Name', visible: true },
            { key: 'addedby', label: 'Added by', visible: true },
            { key: 'addedon', label: 'Added on', visible: true },
            { key: 'actions', label: 'Actions', visible: true },
          ],
        id:'',
        name:'',
        categorySaving:false,
        categoryEditSaving:false,
        categoryDeleteSaving:false,
      };
    },
    computed: {
      ...productcategoryComputed,
      List() { return this.productcategories.length; },
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.productcategories.map((d) => ({...d }))},
      IsBusy() { let a=false; if (this.productcategories.length>0) { a=false;} else { a=true;} return a },
    },
    mounted() {
      this.fetchCategories();
      this.TotalRows = this.productcategories.length;
      this.isBusy=false;
      document.addEventListener("click", this.handleOutsideHelpClick);
    },
    beforeDestroy() {
      document.removeEventListener("click", this.handleOutsideHelpClick);
    },
    methods: {
      ...productcategoryMethods,
      commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
      closeHelp(popoverId) {
        this.$root.$emit("bv::hide::popover", popoverId);
      },
      closeAllHelp() {
        this.$root.$emit("bv::hide::popover");
      },
      handleOutsideHelpClick(event) {
        const target = event.target;
        if (!target || !target.closest) return;
        if (target.closest(".help-icon") || target.closest(".app-help-popover")) {
          return;
        }
        this.closeAllHelp();
      },
      Filtered(filteredItems) {
        this.TotalRows = filteredItems.length;
        this.currentPage = 1;
      },
      edit(id,name){
        this.id=id;
        this.name=name;
        this.$bvModal.show('edit-category')
      },
      remove(id,name){
        this.id=id;
        this.name=name;
        this.$bvModal.show('delete-category')
      },
      async addCategory() { 
        this.categorySaving = true;
        let formData = new FormData();
        formData.append("name", this.name);
        let url = "/addproductcat";
        try {
          await axios.post(url, formData).then((response) => {
          if (response.status == 200) {
              this.fetchCategories();
              this.$bvModal.hide('new-category');
              this.name="";
          }
          });
        } finally {
          this.categorySaving = false;
        }
      },
      async editCategory(){ 
      this.categoryEditSaving = true;
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("name", this.name);
      let url = "/updateproductcat";
      try {
        await axios.post(url, formData).then((response) => {
          if (response.status == 200) {
            this.fetchCategories();
            this.$bvModal.hide('edit-category');
            this.name="";
          }
        });
      } finally {
        this.categoryEditSaving = false;
      }
      },
      async removeCategory() { 
      this.categoryDeleteSaving = true;
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removeproductcat";
      try {
        await axios.post(url, formData).then((response) => {
          if (response.status == 200) {
            this.fetchCategories();
            this.$bvModal.hide('delete-category');
          }
        });
      } finally {
        this.categoryDeleteSaving = false;
      }
      },
    },
  };
  </script>

<style scoped>
.app-modal-banner {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 0.9rem;
  margin-bottom: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.app-modal-banner-icon {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 38px;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #ffffff;
  font-size: 1.1rem;
  box-shadow: 0 8px 18px rgba(20, 184, 166, 0.22);
}

.app-modal-banner-title {
  font-size: 0.92rem;
  font-weight: 800;
  color: #0f172a;
  line-height: 1.15;
}

.app-modal-banner-sub {
  margin-top: 0.15rem;
  font-size: 0.76rem;
  color: #475569;
  line-height: 1.35;
}

.app-modal-banner-sub i {
  color: #0f766e;
  font-size: 0.95rem;
  vertical-align: -2px;
}

.field-label {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0.4rem;
  font-size: 0.84rem;
  font-weight: 600;
  color: #1f2937;
}

.help-icon {
  font-size: 1rem;
  color: #94a3b8;
  cursor: help;
  transition: color 0.18s ease, transform 0.18s ease;
}

.help-icon:hover,
.help-icon:focus {
  color: #0f766e;
  transform: translateY(-1px);
  outline: none;
}
</style>

<style>
.app-help-popover.popover {
  max-width: 340px;
  min-width: 280px;
  border: 1px solid #cbd5e1;
  border-radius: 14px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.18);
  background: #ffffff;
  font-family: inherit;
}

.app-help-popover .popover-header {
  padding: 0.5rem 0.6rem 0.5rem 0.9rem;
  border-bottom: 1px solid #e2e8f0;
  border-top-left-radius: 13px;
  border-top-right-radius: 13px;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #ffffff;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.01em;
}

.app-help-popover .popover-body {
  padding: 0.85rem 0.95rem;
  font-size: 0.85rem;
  line-height: 1.55;
  color: #1f2937;
}

.app-help-popover .popover-body strong {
  color: #0f766e;
  font-weight: 700;
}

.app-help-popover-titlebar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.app-help-popover-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 999px;
  border: 0;
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
  font-size: 1rem;
  line-height: 1;
  padding: 0;
  cursor: pointer;
  transition: background-color 0.18s ease, transform 0.18s ease;
}

.app-help-popover-close:hover,
.app-help-popover-close:focus {
  background: rgba(255, 255, 255, 0.35);
  transform: scale(1.06);
  outline: none;
}

.app-help-popover-close i {
  font-size: 0.95rem;
}

.app-help-popover.bs-popover-right > .arrow::after,
.app-help-popover.bs-popover-auto[x-placement^="right"] > .arrow::after {
  border-right-color: #ffffff;
}

.app-help-popover.bs-popover-right > .arrow::before,
.app-help-popover.bs-popover-auto[x-placement^="right"] > .arrow::before {
  border-right-color: #cbd5e1;
}
</style>
